import styled from 'styled-components'

export const Container = styled.div``

export const ActionBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const ActionBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ActionBarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const SectionTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0;
`

export const ControlsSelected = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
`

export const UnlockBtn = styled.button`
  height: 38px;
  background: white;
  color: var(--vo-slate);
  border: 1.5px solid var(--vo-line);
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover { background: var(--vo-mist); }
  &:disabled { opacity: .5; cursor: not-allowed; }
`

export const ApproveBtn = styled.button`
  height: 38px;
  background: var(--vo-success);
  color: white;
  border: none;
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { background: color-mix(in srgb, var(--vo-success) 80%, black); }
  &:disabled { opacity: .5; cursor: not-allowed; }
`

export const ApproveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const CaptionText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-danger);
  margin-top: 4px;
`

export const TablePaper = styled.div`
  border: 1px solid var(--vo-cloud);
  border-radius: 10px;
  overflow: hidden;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHeader = styled.thead`
  background: var(--vo-mist);
`

export const TableHeaderCell = styled.th`
  padding: 10px 16px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--vo-slate);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: .06em;
  border-bottom: 1px solid var(--vo-cloud);
`

export const TableHeaderCellCenter = styled(TableHeaderCell)`
  width: 36px;
  padding: 10px 8px 10px 14px;
  text-align: center;
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  border-bottom: 1px solid var(--vo-mist);
  &:last-child { border-bottom: none; }
  &:hover { background: var(--vo-capri-25); }
`

export const TableCell = styled.td`
  padding: 10px 16px;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-ink);
`

export const TableCellCenter = styled(TableCell)`
  padding: 10px 8px 10px 14px;
  text-align: center;
`

export const ControlDescription = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink);
  margin: 0 0 3px;
`

export const ControlDomain = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: var(--vo-slate);
  text-transform: uppercase;
  letter-spacing: .06em;
  margin: 0;
`

export const LevelChip = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-brand);
  background: var(--vo-capri-50);
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-block;
`

export const GapChip = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-block;
  ${({ $variant }) =>
    $variant === 'success'
      ? 'color: var(--vo-success); background: var(--vo-success-10);'
      : 'color: var(--vo-danger); background: var(--vo-danger-10);'}
`

export const NoEvidenceText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  font-style: italic;
  color: var(--vo-steel);
`

export const EmptyText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  color: var(--vo-slate);
  text-align: center;
  display: block;
  padding: 24px 0;
`

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  color: ${({ $malicious }) => $malicious ? 'var(--vo-danger)' : 'var(--vo-slate)'};
  &:hover {
    background: var(--vo-mist);
    color: ${({ $malicious }) => $malicious ? 'var(--vo-danger)' : 'var(--color-brand)'};
  }
  &:disabled { opacity: .4; cursor: not-allowed; }
`

export const LockChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  border: 1px solid ${({ $locked }) => $locked ? 'var(--vo-line)' : 'color-mix(in srgb, var(--vo-warning) 30%, transparent)'};
  color: ${({ $locked }) => $locked ? 'var(--vo-slate)' : 'var(--vo-warning)'};
  background: ${({ $locked }) => $locked ? 'transparent' : 'var(--vo-heatmap-risky)'};
`

export const NotesSection = styled.div`
  margin-top: 16px;
`
